import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap'; 
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectStoreComponent } from '../select-store/select-store.component';
import { MultipleSelectItemComponent } from '../multiple-select-item/multiple-select-item.component';
import { DataService } from "../../services/data.service";
import { SelectExecutiveComponent } from '../select-executive/select-executive.component';
import { SelectJobComponent } from '../select-job/select-job.component';
import { APIService } from '../../api.service';
import { CommonService } from '../../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BatchSelectionComponent } from '../batch-selection/batch-selection.component';

@Component({
  selector: 'app-transaction-jobs',
  templateUrl: './transaction-jobs.component.html',
  styleUrls: ['./transaction-jobs.component.scss']
})
export class TransactionJobsComponent implements OnInit {

  modalReference: any;
  id: number = 0;
  rights = {
    materialIssue: true,
    storeSelect: true
  }
  frmStore = {
    id: 0,
    selID: 0,
    name: ''
  }
  executive = {
    id: 0,
    selID: 0,
    name: ''
  }
  wip = { 
    no: 0,
    selID: 0,
    id: 0 
  }
  orderID: string = '';
  title: string = '';
  stores: any = [];
  store = {
    id: 0,
    name: ''
  }
  isWeb: boolean = true;
  totalItems: number = 0;
  issueQty: number = 0;
  xnCode: any;
  jarvisData: any = [];
  MTbl: any = [];
  firstTime: number = 1;
  storeItems: any = [];
  getAllItems: any = [];
  jobItems: any = [];
  ERP_Cfg: any = [];
  isShowPrevNo: boolean = false;
  prevXnCode: string = '';
  executives: any = [];
  WIPNos: any = [];
  search = {term: ''};
  Cfg_AgnCfg: any = [];
  lastXNNos: any = [];
  isFromPrdJob: boolean = false;
  batchCnt: any = 0;
  batchMode: any = '';
  batchList: any = [];
  prTypeID: any = 1;
  prdTypeID: any = 1;
  // isShowBatchEdt: boolean = false;
  constructor(private modalService: NgbModal, private _Activatedroute: ActivatedRoute, public activeModal: NgbActiveModal, private appService: DataService, private apiService: APIService, private router: Router, private commonService: CommonService,private SpinnerService: NgxSpinnerService) { }
  
  ngOnInit(): void {
    // id = if st > 0 store selected
    // id = if type == 1 : Material Consumption
    // id == 6 : Issue for Production

    this.id = this._Activatedroute.snapshot.params['id'];

    if(this._Activatedroute.snapshot.params['jobID']) {
      this.wip.selID = this._Activatedroute.snapshot.params['jobID'];
      this.isFromPrdJob = true;
    }

    this.prdTypeID = this._Activatedroute.snapshot.params['pTID'] ? this._Activatedroute.snapshot.params['pTID'] : 1
    // if(this._Activatedroute.snapshot.params['st']) {
    //   this.st = this._Activatedroute.snapshot.params['st'];

    //   this.storeName = this.stores.filter((a: any) => {return a.id == this.st})[0].name;
    //   this.isStoreSelected = true;
    // }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    } 

    this.isWeb = this.apiService.apiCheckWeb();

    var tblM = this.apiService.getCookie("M");
    if(tblM) {
      this.MTbl = JSON.parse(tblM);
    }

    this.apiService.getIDB('erp_inv', (erp_inv: any) => {
      if (erp_inv && erp_inv.length > 0) {
        this.getAllItems = erp_inv;
      }
      else{
        this.apiService.fetchERPStockItems('RESET', (res: any) => {
          if(res && res.length > 0) {
             this.getAllItems = res;
          }
      });
      }
    });

    var tblERP_Cfg = this.apiService.getCookie("ERP_Cfg");
    if(tblERP_Cfg) {
      this.ERP_Cfg = JSON.parse(tblERP_Cfg);
    }

    let tblJ = this.apiService.getCookie("J");

    if(tblJ) {
      let tmpTblJ = JSON.parse(tblJ);
      this.executives = tmpTblJ;
      if(this.executives.length == 1){
        this.executive.selID = this.executives[0].UserID;
      }
      else{
        this.executive.selID = 0;
      } 
    }

    // let tmpLastXnNo = this.ERP_Cfg[0].LastXnNo;
    // if(tmpLastXnNo){
    //   if(tmpLastXnNo.match(/^[0-9]+$/) != null) {
    //     this.isShowPrevNo = false;
    //     this.xnCode = Number(tmpLastXnNo) + 1;
    //   } 
    //   else {
    //     this.isShowPrevNo = true;
    //     this.prevXnCode = tmpLastXnNo;
    //   }
    // }

    this.getStores();
    this.getWIPNos();

    this.appService.projectData.subscribe((a: any) => {
      debugger
     this.prTypeID = a.prTypeID
    });

    //Get Store
    this.appService.store.subscribe((a: any) => {
      this.frmStore.id = a.id;
      this.frmStore.name = a.name;
    });

    
    this.appService.items.subscribe((value :any) => {
      
      value.forEach((a: any) => {
        // this.batchCnt = 0;
        if(a.BatchType == 1 || a.BatchType == 2) {
          a.hasBatches = true;
          this.batchCnt = this.batchCnt + 1
        }
        else {
          a.hasBatches = false;
        }
        if(a.Batches)
        {
          let tempBatchQtyList = a.Batches.filter((a: any) => a.Q > 0);
          if(tempBatchQtyList.length > 0){
            a.isShowBatchEdt = false;
          }
        }
      this.items.push({
        DoneQty: Number(0).toFixed(a.SKUPrecision),
        MID: a.ItemID,
        PlanQty: Number(0).toFixed(a.SKUPrecision),
        SKU: a.SKU,
        StrQty: Number(a.StoreQty).toFixed(a.SKUPrecision),
        Prcsn: a.SKUPrecision,
        issueQty: '',
        ItemName: a.ItemName,
        DefStockRate: a.DefStockRate,
        hasBatches: a.hasBatches,
        Batches : a.Batches ? a.Batches : [],
        BatchType : a.BatchType,
        isShowBatchEdt: a.isShowBatchEdt
      })  
      });  
    });

    document.getElementById('openModal')?.click();
    
    if(this.id == 6) {
      this.title = 'Issue for Production';
    }
    else if(this.id == 7) {
      this.title = 'Receive Unused';
    }
    else if(this.id == 8) {
      this.title = 'Receive from Production';
    } else {
      this.title = '';
    }

    var tmpCfg_AgnCfg = this.apiService.getCookie("Cfg_AgnCfg");
    if(tmpCfg_AgnCfg) {
      this.Cfg_AgnCfg = JSON.parse(tmpCfg_AgnCfg);
      if(this.Cfg_AgnCfg[0].LastXnNos){
        this.lastXNNos = JSON.parse(this.Cfg_AgnCfg[0].LastXnNos);

        let tmpNo = this.id == 6 ? 5 : this.id == 8 ? 7 : this.id == 7 ? 2 : 0;
        let tmpType = 'XN-' + tmpNo;

        this.lastXNNos = this.lastXNNos.filter((a: any) => a.XnTyp == tmpType);
      }
    }
    
    if(this.lastXNNos.length > 0) {
      let tmpLastXnNo = this.lastXNNos[0].LastNo;
      if(tmpLastXnNo){
        // if(tmpLastXnNo.match(/^[0-9]+$/) != null) {
        //   this.isShowPrevNo = false;
        //   this.xnCode = Number(tmpLastXnNo) + 1;
        // } 
        // else {
        //   this.isShowPrevNo = true;
        //   this.prevXnCode = tmpLastXnNo;
        // }
        if(isNaN(tmpLastXnNo)) {
          this.isShowPrevNo = true;
          this.prevXnCode = tmpLastXnNo;
        } 
        else {
          this.isShowPrevNo = false;
          this.xnCode = Number(tmpLastXnNo) + 1;
        }
      }
    }
    else {
      this.xnCode = 1;
    }

     // Get Batches Data for perticular Item
     this.appService.batches.subscribe((value: any) => {
      if(value) {
        // this.batchList  = value.batchList;
        this.items.forEach((element: any) => {
          if (value.itemID == element.MID) {
            element.Batches = value.batchList;
            element.sumBatchesQty = value.sumBatchesQty;
            element.oldBatchList = value.oldBatchList;
            element.isShowBatchEdt = value.isShowEdt
            
          }
        });
      }
      
    });

    //this.selectStore();

  }

  items: any = [];

  openItemSelect(content: any) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static', keyboard: false});
    this.modalReference.componentInstance.typeID = this.id;
    this.modalReference.componentInstance.it = this.items.map((a: any) => a.ItemID);
    this.modalReference.componentInstance.st = this.frmStore.id;
    this.modalReference.componentInstance.stc = 0;
    this.modalReference.componentInstance.isMade = 1;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
  

  }

  closeModal() {
    this.modalReference.close();
  }

  selectStore() {
   // this.modalReference = this.modalService.open(content);
  this.modalReference = this.modalService.open(SelectStoreComponent, { backdrop: 'static', keyboard: false });
   this.modalReference.componentInstance.AllOption = 0; 
   this.modalReference.componentInstance.StoreID = this.frmStore.id;
   this.modalReference.componentInstance.mdlRef = this.modalReference; 
   this.modalReference.result.then((result: any) => {
      if (result.length > 0) {
        // this.store.id = this.stores.filter((a: any) => {return a.id == result})[0].id;
        // this.store.name = this.stores.filter((a: any) => {return a.id == result})[0].name;
        this.frmStore.id = result[0].StrID;
        this.frmStore.name = result[0].sNm;
        //this.isStoreSelected = true;
        if(this.firstTime == 1) {
          this.openSelectJob();
        }
        this.getJobItems();
      }
    });

  }


  backBtn() {
    this.router.navigate(['Stock']);
    //window.history.back();
  }

  proposeQty() {
    this.items.map((a: any) => { a.issueQty = a.PlanQty - a.DoneQty } );

    this.items.forEach((b: any) => {
      if(Math.sign(b.issueQty) == -1) {
        b.issueQty = 0;
      }
    });

    this.getTransferQty();
  }

  getTransferQty() {
    this.issueQty = 0;
    for(let i = 0; i < this.items.length; i++) {
      if(this.id == 6){
        if(Number(this.items[i].issueQty) > Number(this.items[i].StrQty)) {
          this.apiService.successAlert(this.items[i].ItemName + ' is out of stock.');
          this.items[i].issueQty = '';
          break;
        }
      }
      

      if(this.items[i].issueQty){
        this.issueQty += Number(this.items[i].issueQty);
      }
    }
  }

  deleteItem(index: number) {
    this.items.splice(index, 1);
  }

  openSelectExecutive() {
    this.modalReference = this.modalService.open(SelectExecutiveComponent, { backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.id = this.executive.id;
    this.modalReference.result.then((result: any) => {
      if(result.length > 0) {
        this.executive.id = result[0].UserID;
        this.executive.name = result[0].Name;
      }
    });
  }

  openSelectJob() {
    debugger
    this.modalReference = this.modalService.open(SelectJobComponent, { backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.WIPNo = this.wip.id;
    this.modalReference.result.then((result: any) => {
      if(result.length > 0) {
        this.orderID = result[0].OrderID;
        this.wip.no = result[0].JobNo;
        this.wip.id = result[0].JobID;
        this.getJobDetails();
      }
    });
  }


  openBatchSelectionMdl(content: any) {
    if(this.id == 7 || this.id == 8 ){
      this.batchMode = "In";
    }
    else if(this.id == 6) {
      this.batchMode = "Out";
    }
    this.modalReference = this.modalService.open(BatchSelectionComponent, { windowClass : "BatchSelection", backdrop: 'static', keyboard: false});
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.modeType = this.batchMode;
    this.modalReference.componentInstance.isFromTrnsJobs = true;
    this.modalReference.componentInstance.isXn = true;
    this.items.forEach((element: any) => {
      if (content.MID == element.MID) {
        this.batchList = [];
        this.batchList = element.Batches; //JSON.parse(element.Batches); 
        this.modalReference.componentInstance.batchesList = this.batchList;
        let tempBatchQtyList = this.batchList.filter((a: any) => a.Q > 0);
        if(tempBatchQtyList.length > 0){
           element.isShowBatchEdt = true;
          }
      } 
      // let tempBatchQtyList = this.batchList.filter((a: any) => a.Q > 0);
      // if(tempBatchQtyList.length > 0){
      //  this.isShowBatchEdt = true;
      // }
    });
    
    
    this.modalReference.componentInstance.itemID = content.MID;
    this.modalReference.componentInstance.xnID =  8;

    this.appService.updateByProduct(content);
  }


  issue() {
  
    if(this.frmStore.id == 0) {
      this.apiService.successAlert('Please select a store.');
      return;
    }

    if(this.executive.id == 0) {
      this.apiService.successAlert('Please select an executive.');
      return;
    }

    if(this.wip.no == 0) {
      this.apiService.successAlert('Please select WIP No.');
      return;
    }

    if(!this.xnCode) {
      this.apiService.successAlert('Please enter Ref No.');
      return;
    }

    // let qtyChk = this.items.filter((o: any) => !o.issueQty || o.issueQty == 0);
    // if((qtyChk.length > 0) && (this.id == 6)) {
    //   this.apiService.successAlert('Please enter quantity of ' + qtyChk[0].ItemName + '.');
    //   return;
    // }

    let chkStock = this.items.filter((p: any) => Number(p.issueQty) > Number(p.StrQty));
    if((chkStock.length > 0) && (this.id == 6)) {
      this.apiService.successAlert('Issue quantity must be less than or equal to stock quantity.');
      return;
    }

    let chkRtnQty = this.items.filter((p: any) => Number(p.issueQty) > Number(p.DoneQty));    
    if((chkRtnQty.length > 0) && (this.id == 7)) {
      this.apiService.successAlert('Actual used quantity (' + chkRtnQty[0].DoneQty + ' ' + chkRtnQty[0].SKU + ') is less than the returned quantity.');
      return;
    }
    let btchQtyCheck = this.items.filter((b: any) => b.issueQty != b.sumBatchesQty && b.hasBatches);
    if (btchQtyCheck.length > 0) {
        this.apiService.successAlert("Please ensure that the total quantity of batches matches the total transaction quantity of " + btchQtyCheck[0].ItemName + ".");
        return;
    }

    let items: any = [];
    let PrdItemsToStore: any = [];
    let RtnItemsToStore: any = [];
    let IssueItemsFromStore: any = [];
    let srNo: number = 1;
    let tempBatchesData: any = [];
    this.items.forEach((e: any) => {
      // if(e.Batches)
      // {
      // //let tempBatchesData =  JSON.stringify(e.Batches)
      //   e.Batches.forEach((b: any) => {
      //     tempBatchesData.push({

      //     })
      //   });
      // }

      if(e.Batches) {
        e.Batches = e.Batches.filter((x: any) => Number(x.Q) != 0);
      }
      if(e.issueQty && e.issueQty > 0) {
        if(this.id == 7){
          RtnItemsToStore.push({
            SrNo: srNo++,
            ItemID: e.MID,
            InQty: parseFloat(e.issueQty) + "",
            OutQty: 0 + "",
            Unit: e.SKU,
            Rate: e.DefStockRate,
            Notes: '',
            BatchID: 0,
            BatchNo: 0,
            Batches: e.Batches ? JSON.stringify(e.Batches) : '[]'
          })
        }

        if(this.id == 6) {
          IssueItemsFromStore.push({
            SrNo: srNo++,
            ItemID: e.MID,
            InQty: 0 + "",
            OutQty: parseFloat(e.issueQty) + "",
            Unit: e.SKU,
            Rate: e.DefStockRate,
            Notes: '',
            BatchID: 0,
            BatchNo: 0,
            Batches: e.Batches ? JSON.stringify(e.Batches) : '[]'
          })
        }

        if(this.id == 8) {
          PrdItemsToStore.push({
            SrNo: srNo++,
            ItemID: e.MID,
            InQty: parseFloat(e.issueQty) + "",
            OutQty:  + "",
            Unit: e.SKU,
            Rate: e.DefStockRate,
            Notes: '',
            BatchID: 0,
            BatchNo: 0,
            Batches: e.Batches ? JSON.stringify(e.Batches) : '[]'
          })
        }
        
      }
    });

    if(this.id == 7 && RtnItemsToStore.length == 0){
      this.apiService.successAlert('At least one item must have non-zero quantity.');
      return;
    }
    else if(this.id == 6 && IssueItemsFromStore.length == 0){
      this.apiService.successAlert('At least one item must have non-zero quantity.');
      return;
    }
    else if(this.id == 8 && PrdItemsToStore.length == 0){
      this.apiService.successAlert('At least one item must have non-zero quantity.');
      return;
    }

    let obj = [{
      JobID: this.wip.id,
      PrdItemsToStore: JSON.stringify(PrdItemsToStore),
      RtnItemsToStore: JSON.stringify(RtnItemsToStore),
      IssueItemsFromStore: JSON.stringify(IssueItemsFromStore),
      StoreID: this.frmStore.id,
      ExecUserID: this.executive.id, //this.jarvisData[0].UserID
      XnNo: this.xnCode 
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'setXnItems',
      moduleID: 7,
      data: JSON.stringify(obj)
    }];

    this.apiService.swalConfirm("Are you sure you want to enter this " + this.title.toLowerCase() + " transaction?", () => {
      this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
    });
    
    // if (confirm("Are you sure you want to " + this.title + "?")) {
    //   this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
    // }

  }

  successEntry(res: any){
    if (res.error) {
      this.apiService.successAlert(res.message);
    }
    else {
      let altTxt = '';
      this.id == 6 ? altTxt = 'Issued for production' : this.id == 7 ? altTxt = 'Received unused' : altTxt = 'Received from production';
      this.apiService.successAlert(altTxt + '.');
      console.log("Res", res);
     
      // get XnId from success response.
      let responseData = JSON.parse(res.updatePackage);
      console.log("responseData", responseData);
      let xnID: number =  responseData.Table[0].XnID;

      var abcCfg_AgnCfg;
      abcCfg_AgnCfg = this.apiService.getCookie("Cfg_AgnCfg");
      if(abcCfg_AgnCfg) {
        abcCfg_AgnCfg = JSON.parse(abcCfg_AgnCfg);
      }

      let latNos = JSON.parse(abcCfg_AgnCfg[0].LastXnNos);
      let tmpNo = this.id == 6 ? 5 : this.id == 8 ? 7 : this.id == 7 ? 2 : 0;
      let tmpType = 'XN-' + tmpNo;
      let index = 0;
      let tmpFilter = this.lastXNNos.filter((a: any) => a.XnTyp == tmpType);

      if(tmpFilter.length > 0) {
        latNos.forEach((element: any, index: number) => {
          if(element.XnTyp == tmpType) {
            element.LastNo = this.xnCode;
          }
        });
      }
      else {
        let tmpObj = {
          "XnTyp": tmpType,
          "LastNo": this.xnCode
        }

        latNos.push(tmpObj);
      }
      
      this.printTranjection(xnID);

      abcCfg_AgnCfg[0].LastXnNos = JSON.stringify(latNos);
      this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(abcCfg_AgnCfg));

      if(this.isFromPrdJob == true){
        let selectPrID = this.apiService.getCookie("prTypeID");
        if(selectPrID == '2'){
          this.prTypeID = 2
        }
        let urlCheck: string = "";
        if (this.apiService.fn_isLiveURL() == true) {
          urlCheck = "/ERP"
        }
        if(this.prTypeID == 2){
          urlCheck += "/Projects?p=2"
         
        }
        else{
          urlCheck += "/ProductionList?p=1"
        }
        window.open(urlCheck, "_self");
        // this.router.navigate(['ProductionList?=1']);
        // if(this.prTypeID == 2)
        // {
        //   this.router.navigate(['Projects?p=2']);
        // }
        // else{
        //   this.router.navigate(['ProductionList?p=1']);
        // }
        
      }
      else{
        this.router.navigate(['Stock']);
      }      
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
      //alert(this.title + ' done!');
    }
  }

  getJobDetails() {
debugger
    let obj = [{
      JobID: this.wip.id
    }];
    
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getPrdJobDetails',
      moduleID: 8,
      data: JSON.stringify(obj)
    }];

    this.apiService.getData(myParams, this.successJobDetails.bind(this), this.failureResp.bind(this));
  }

  successJobDetails(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          this.firstTime = 0;
          let cData = reponseData.Table1;
          if(this.id == 6 || this.id == 7) {
            this.jobItems = reponseData.Table2;
          } else {
            this.jobItems = reponseData.Table3;
          }
          this.getJobItems();
        }
      }
    }
  }

  getJobItems() {
    debugger
    this.items = [];
    this.jobItems.forEach((a: any) => {
      if((a.StoreBatches) && (this.isJSON(a.StoreBatches))){
        a.StoreBatches = JSON.parse(a.StoreBatches);
      }
      if((a.Units) && (this.isJSON(a.Units))) {
        a.Units = JSON.parse(a.Units);
      }
      let tmpStore = a.StoreBatches.filter((s: any) => s.SID == this.frmStore.id);
      //this.batchCnt = 0;
      if(a.BatchType == 1 || a.BatchType == 2) {
        a.hasBatches = true;
        this.batchCnt = this.batchCnt + 1
      }
      else {
        a.hasBatches = false;
      }
      if(a.Batches != '[]' ||  a.Batches != undefined){
        let batchData   = JSON.parse(a.Batches);
        a.batchesList = batchData;
        this.batchList = [];	
        this.batchList = batchData;
        this.batchList.forEach((a: any) => {	
          a.CQ = a.Q; 
          a.Q = 0;
       })	
       debugger
       let tempBatchQtyList = this.batchList.filter((a: any) => a.Q == 0);
       if(tempBatchQtyList.length > 0){
        a.isShowBatchEdt = false;
       }
      }
     
       
      this.items.push({
        DoneQty: this.id == 6 || this.id == 7 ? Number(a.UsedQty).toFixed(a.Units[0].Prcsn) : Number(a.GenQty).toFixed(a.Units[0].Prcsn),
        MID: this.id == 6 || this.id == 7 ? a.MID : a.PID,
        PlanQty: this.id == 6 || this.id == 7 ? Number(a.PlanQty).toFixed(a.Units[0].Prcsn) : Number(a.PlanQty - a.RejQty).toFixed(a.Units[0].Prcsn),
        SKU: a.SKU,
        StrQty: tmpStore.length > 0 ? Number(tmpStore[0].Q).toFixed(a.Units[0].Prcsn) : Number(0).toFixed(a.Units[0].Prcsn),
        Prcsn: a.Units[0].Prcsn,
        issueQty: '',
        ItemName: '',
        DefStockRate: 0,
        hasBatches: a.hasBatches,
        Batches : this.batchList ? this.batchList : [],
        BatchType : a.BatchType,
        isShowBatchEdt: a.isShowBatchEdt
      })
    });
    
    this.items.forEach((a: any) => {
      this.getAllItems.forEach((b: any) => {
        if(a.MID == b.ItemID) {
          a.ItemName = b.ItemName;
          a.DefStockRate = b.DefStockRate;
        }
      });
      // this.batchList = [];
      // this.batchList = JSON.parse(a.Batches);//a.Batches; //JSON.parse(element.Batches); 
      //this.modalReference.componentInstance.batchesList = this.batchList;
    });
  }

  prcisionCheck(obj: any) {
    obj.issueQty = this.commonService.PrecisionwiseValue(obj.issueQty + '', obj.Prcsn);
  }

  isJSON(str: any) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
  }

  openModal(sel: any) {
    this.modalReference = this.modalService.open(sel, {windowClass: 'transactionJobModdal', backdrop: 'static', keyboard: false});
  }

  getStores() {
    let data = [{
    }];
    
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getConfig',
      moduleID: 6,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successConfigResp.bind(this), this.failureResp.bind(this));
  }

  //successConfigResp - success  get handler
  successConfigResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let cData = reponseData.Table2;
          let tmpStore = cData[0].Stores; 
          this.stores = JSON.parse(tmpStore);
          if(this.jarvisData[0].UserID != this.MTbl[0].AdminUserID){
            let selectedStore = this.stores;
            this.stores = [];
            for(let i: number = 0; i < selectedStore.length; i++){
              if(selectedStore[i].UIDs){
                let selectedUsers = String(selectedStore[i].UIDs).split(",");
                for(let j: number = 0; j < selectedUsers.length; j++){
                  if(selectedUsers[j] == this.jarvisData[0].UserID){
                    this.stores.push(selectedStore[i]);
                  }
                }                
              }
              else{
                this.stores.push(selectedStore[i]);
              }
            }
          }


          this.stores = this.stores.sort((a: any, b: any) => a.sNm.localeCompare(b.sNm))

          if(this.stores.length == 1){
            this.frmStore.selID = this.stores[0].StrID;
          }
          else{
            this.frmStore.selID = 0;
          } 
        }
      }
    }
  }


  getWIPNos() {
    debugger
    //this.WIPNos = ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010'];

    let data = [{
      statusID: 1,
      month: 1,
      year: 2021,
      jobTypeID: this.prdTypeID
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getPrdJobs',
      moduleID: 8,
      data: JSON.stringify(data)
    }];
    
    this.apiService.getData(myParams, this.successWIPResp.bind(this), this.failureResp.bind(this));
  }

  //successConfigResp - success  get handler
  successWIPResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let cData = reponseData.Table1;
          this.WIPNos = cData;
          this.WIPNos.forEach((element: any) => {
            element.isSelected = false;
            element.TargetDT = new Date(element.TargetDT);
            element.Gen = JSON.parse(element.Generation);
          });
          if(this.wip.selID != 0) {
            this.WIPNos.forEach((element: any) => {
              if(element.JobID == this.wip.selID) {
                element.isSelected = true;
              }
            });
          }

          this.WIPNos.forEach((a: any) => {
            let tmpItem = a.Gen;
            tmpItem.forEach((c: any) => {
              this.getAllItems.forEach((b: any) => {
                if(c.PID == b.ItemID) {
                  c.ItemName = b.ItemName;
                }
              });
            });
            
          });
        }
      }
    }
  }

  WIPNoSelect(obj: any) {
    this.WIPNos.forEach((element: any) => {
      element.isSelected = false;
    });
    obj.isSelected = true;
    this.wip.selID = obj.JobID;
  }


  selectJOBDetails() {
    if(this.frmStore.selID == 0) {
      this.apiService.successAlert('Please select a store.');
      return;
    }

    else if(this.executive.selID == 0) {
      this.apiService.successAlert('Please select an executive.');
      return;
    }

    else if(this.wip.selID == 0) {
      this.apiService.successAlert('Please select WIP No.');
      return;
    }

    else {
        let selStore = this.stores.filter((a: any) => a.StrID == this.frmStore.selID);
        if(selStore.length > 0) {
          this.frmStore.id = selStore[0].StrID;
          this.frmStore.name = selStore[0].sNm;
        }

        let selExec = this.executives.filter((a: any) => a.UserID == this.executive.selID);
        if(selExec.length > 0) {
          this.executive.id = selExec[0].UserID;
          this.executive.name = selExec[0].Name;
        }

        let selJob = this.WIPNos.filter((a: any) => a.JobID == this.wip.selID);
        if(selJob.length > 0) {
          this.orderID = selJob[0].OrderID;
          this.wip.no = selJob[0].JobNo;
          this.wip.id = selJob[0].JobID;

          this.getJobDetails();
        }
        
        this.modalReference.close();
    }
  }

// Dilivery Challan Print data
  printTranjection(id: number){
    var XnID = this.commonService.encryptData(id);
    let AgencyID = this.commonService.encryptData(this.jarvisData[0].AgencyIDs);
    let target: string = "_blank";
    // if(this.isWeb == false){
    //   target = "_self";
    // }
    window.open('transactionHistory?XnID=' + XnID + "&aid=" + AgencyID, target, 'Height= 800px, Width= 1000px, padding:10px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

}
